// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.submit[data-v-3509db0f] {\r\n  /*border-color: #0158ff !important;*/\r\n  /*background-color: #0158ff !important;*/\r\n  /*color: #ffffff;*/\r\n  margin-left: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
